import React, { useState } from "react";
import { View, Text, StyleSheet, TouchableOpacity } from "react-native";
import { Input } from "react-native-elements";

const PercentageScreen = ({ navigation }) => {
  const [minFirst, setMinFirst] = useState("");
  const [maxFirst, setMaxFirst] = useState("");
  const [minSecond, setMinSecond] = useState("");
  const [maxSecond, setMaxSecond] = useState("");
  //const [totalSum, setTotalSum] = useState("");
  const [time, setTime] = useState("");
  const [prevFirst, setPrevFirst] = useState("");
  const [prevSecond, setPrevSecond] = useState("");
  const [prevAnswer, setPrevAnswer] = useState("");
  const [first, setFirst] = useState("");
  const [second, setSecond] = useState("");
  const [right, setRight] = useState("0");
  const [wrong, setWrong] = useState("0");
  const [hide1, setHide1] = useState(false);
  const [hide2, setHide2] = useState(false);
  const [timer, setTimer] = useState("");
  const [userAnswer, setUserAnswer] = useState("");
  const [calculatedAnswer, setCalculatedAnswer] = useState("");
  const [hide3, setHide3] = useState(false);
  const [attempt, setAttempt] = useState("0");

  const onChangeUtil = () => {
    if (
      maxFirst.length == 0 ||
      minFirst.length == 0 ||
      maxSecond.length == 0 ||
      time.length == 0 ||
      minSecond.length == 0 ||
      parseInt(maxSecond) < parseInt(minSecond) ||
      parseInt(maxFirst) < parseInt(minFirst)
    ) {
      alert("Please Enter The Field Properly");
    } else {
      onChange();
    }
  };

  const onChange = () => {
    setHide1(true);
    setHide2(true);
    setHide3(false);
    setPrevFirst("");
    setPrevAnswer("");
    setPrevSecond("");
    setRight("0");
    setWrong("0");
    setAttempt("0");
    var count = 0;
    var myVar = setInterval(() => {
      if (count <= time) {
        setTimer(count);
        count++;
      } else {
        clearInterval(myVar);
        setHide3(true);
        //    alert("OOPs Times Up!!");
      }
    }, 1000);

    var a = Math.floor(
      Math.random() * (parseInt(maxFirst) - parseInt(minFirst)) +
        parseInt(minFirst)
    );
    var b = Math.floor(
      Math.random() * (parseInt(maxSecond) - parseInt(minSecond)) +
        parseInt(minSecond)
    );
    var ans = (a * b) / 100;
    console.log(a, b, ans);
    setFirst(a);
    setSecond(b);
    setCalculatedAnswer(ans);
  };

  const checkAnswer = () => {
    setUserAnswer("");
    setAttempt("" + (parseInt(attempt) + 1) + "");
    if (parseInt(calculatedAnswer) == parseInt(userAnswer)) {
      setRight("" + (parseInt(right) + 1) + "");
      setPrevFirst(first);
      setPrevSecond(second);
      setPrevAnswer(calculatedAnswer);

      var a = Math.floor(
        Math.random() * (parseInt(maxFirst) - parseInt(minFirst)) +
          parseInt(minFirst)
      );
      var b = Math.floor(
        Math.random() * (parseInt(maxSecond) - parseInt(minSecond)) +
          parseInt(minSecond)
      );
      var ans = (a * b) / 100;
      console.log(a, b, ans);
      setFirst(a);
      setSecond(b);
      setCalculatedAnswer(ans);
    } else {
      setWrong("" + (parseInt(wrong) + 1) + "");
      setPrevFirst(first);
      setPrevSecond(second);
      setPrevAnswer(calculatedAnswer);

      var a = Math.floor(
        Math.random() * (parseInt(maxFirst) - parseInt(minFirst)) +
          parseInt(minFirst)
      );
      var b = Math.floor(
        Math.random() * (parseInt(maxSecond) - parseInt(minSecond)) +
          parseInt(minSecond)
      );
      var ans = (a * b) / 100;
      console.log(a, b, ans);
      setFirst(a);
      setSecond(b);
      setCalculatedAnswer(ans);
    }
  };
  const goBack = () => {
    setHide1(false);
    setHide2(false);
    setHide3(false);
    setTimer("0");
  };

  return (
    <>
      {!hide1 && (
        <View>
          <Input
            keyboardType={"number-pad"}
            label="Enter Lowest number to percentage"
            value={minFirst}
            onChangeText={(newValue) => setMinFirst(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Input
            keyboardType={"number-pad"}
            label="Enter Highest number to percentage"
            value={maxFirst}
            onChangeText={(newValue) => setMaxFirst(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Input
            keyboardType={"number-pad"}
            label="Enter Lowest number to percentage by"
            value={minSecond}
            onChangeText={(newValue) => setMinSecond(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Input
            keyboardType={"number-pad"}
            label="Enter Highest number to percentage by"
            value={maxSecond}
            onChangeText={(newValue) => setMaxSecond(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <Input
            keyboardType={"number-pad"}
            label="Enter Total Time in Seconds"
            value={time}
            onChangeText={(newValue) => setTime(newValue)}
            autoCapitalize="none"
            autoCorrect={false}
          />
          <TouchableOpacity style={styles.button} onPress={onChangeUtil}>
            <Text>Start</Text>
          </TouchableOpacity>
        </View>
      )}
      {hide2 && (
        <>
          <Text style={styles.text}>
            {timer}/{time}
          </Text>
          <Text style={styles.text}>Attempted={attempt}</Text>
          <Text style={styles.text}>Right={right}</Text>
          <Text style={styles.text}>Wrong={wrong}</Text>
          {prevAnswer.length != 0 && (
            <Text style={styles.text}>
              {prevFirst}%{prevSecond}={prevAnswer}
            </Text>
          )}
          <Text style={styles.text}>
            {first}%{second}
          </Text>
          <Input
            keyboardType={"number-pad"}
            label="Enter Your Answer"
            value={userAnswer}
            onChangeText={(newValue) => setUserAnswer(newValue)}
          />
          {!hide3 && (
            <TouchableOpacity style={styles.button} onPress={checkAnswer}>
              <Text>Check Your Answer</Text>
            </TouchableOpacity>
          )}
        </>
      )}
      {hide3 && (
        <>
          <TouchableOpacity style={styles.buttonDanger} onPress={onChange}>
            <Text style={styles.textDanger}>Start Again</Text>
          </TouchableOpacity>
          <TouchableOpacity style={styles.button} onPress={() => goBack()}>
            <Text style={styles.text}>Go To Percentage Screen</Text>
          </TouchableOpacity>
        </>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  button: {
    alignItems: "center",
    borderColor: "black",
    borderWidth: 2,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
  text: {
    textAlign: "center",
    fontSize: 30,
  },
  textDanger: {
    textAlign: "center",
    fontSize: 30,
    color: "red",
    fontWeight: "bold",
  },
  buttonDanger: {
    alignItems: "center",
    borderColor: "red",
    borderWidth: 5,
    borderRadius: 180,
    padding: 10,
    margin: 10,
  },
});

export default PercentageScreen;
